import { useState } from 'react';
import { createPortal } from 'react-dom';

export default function ArchivePopup({ itemName, onConfirm, onClose }) {
  const [reason, setReason] = useState('');

  return createPortal(
    <>
      <div className="quickpay-backdrop" onClick={onClose} />
      <div className="quickpay-modal" role="dialog">
        <div className="quickpay-title"><span>Archive {itemName || 'this item'}?</span></div>
        <div className="quickpay-row">
          <label>Reason <span className="muted-xs">(optional)</span></label>
          <input type="text" value={reason} onChange={e => setReason(e.target.value)} placeholder="Why are you archiving this?" autoFocus
            style={{ width: '100%', padding: '8px 10px', border: '1px solid var(--border-input)', borderRadius: 'var(--radius-md)', fontFamily: 'inherit', fontSize: 'var(--text-sm)' }} />
        </div>
        <div className="quickpay-actions">
          <button className="btn btn-secondary btn-sm" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger btn-sm" onClick={() => onConfirm(reason)}>Archive</button>
        </div>
      </div>
    </>,
    document.body
  );
}
